import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/ai-service")({
  beforeLoad: () => {
    throw redirect({ to: "/terms", hash: "ai-service" });
  },
});
